// Lore.js
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { IoArrowBackOutline } from 'react-icons/io5';
import catImage from '../assets/cat.png';
import catImage1 from '../assets/cat_1.png';
import bgImage from '../assets/bg.png'; // Importando a imagem do background


const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideIn = keyframes`
  from {
    transform: translateX(-100px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const Container = styled.div`
  background-image: url(${bgImage});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  position: relative;
  overflow-x: hidden;

  @media (max-width: 1200px) {
    padding: 40px 20px;
    height: auto;
  }
`;

const Layout = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  animation: ${fadeIn} 1s ease-out;
  max-width: 1800px;
  margin: 0 auto;

  @media (max-width: 1200px) {
    flex-direction: column;
    gap: 20px;
  }
`;

const ImageCard = styled.div`
  background-color: #fff;
  border-radius: 15px;
  width: 500px;
  height: 800px;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 1200px) {
    width: 100%;
    max-width: 400px;
    height: 600px;
  }

  @media (max-width: 768px) {
    height: 400px;
  }
`;

const Card = styled.div`
  background-color: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 40px;
  max-width: 600px;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  text-align: center;
  font-family: 'Caveat', cursive;
  line-height: 1.8;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.02);
  }

  @media (max-width: 768px) {
    padding: 20px;
    margin: 20px 0;
  }
`;

const BackButton = styled.div`
  position: fixed;
  top: 20px;
  left: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-family: 'Caveat', cursive;
  animation: ${slideIn} 0.5s ease-out;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 10px 15px;
  border-radius: 30px;
  transition: all 0.3s ease;
  z-index: 10;

  &:hover {
    transform: translateX(5px);
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }

  svg {
    font-size: 24px;
    color: #333;
    transition: transform 0.3s ease;
  }

  span {
    margin-left: 8px;
    font-size: 20px;
    font-weight: bold;
    color: #333;
  }

  @media (max-width: 768px) {
    position: absolute;
    top: 10px;
    left: 10px;
  }
`;

const Text = styled.p`
  font-size: 20px;
  color: #333;
  animation: ${fadeIn} 1.5s ease-out;
  margin-bottom: 20px;
  text-shadow: 1px 1px 1px rgba(255, 255, 255, 0.5);
  
  &:last-child {
    margin-bottom: 0;
    font-weight: bold;
    font-size: 22px;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;

  ${ImageCard}:hover & {
    transform: scale(1.05);
  }
`;

const Lore = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <BackButton onClick={() => navigate(-1)}>
        <IoArrowBackOutline />
      </BackButton>
      <Layout>
        {/* Left Image Card */}
        <ImageCard>
          <Image src={catImage1} alt="Left Image" />
        </ImageCard>

        {/* Main Content Card */}
        <Card>
          <Text>
            Two years ago, this crazy cat showed up at our building. A cat that looked totally
            normal, or so we thought. We took care of him, got him cleaned up, and tried to find
            him a home. But guess what? Nobody wanted him.
          </Text>
          <Text>
            Little Paul (yep, that’s what we named him) got super attached to us, and honestly, we
            kinda fell for him too. So, we decided to keep him. That’s when we realized... this cat
            is nuts! He’s the funniest, most chaotic little guy you’ll ever meet. Enemy number one
            of peace and quiet.
          </Text>
          <Text>
            He’s been with us for two years now, and let me tell you, this dude has already burned
            through a few lives. Once, we found him drooling like crazy—probably ate some garbage or
            something wild off the street. Another time, we came home from work and found him (no
            joke) run over with one eye popping out of his skull. We rushed him to the vet, and after
            a long, stressful surgery, they managed to save him. But yeah, there went another life.
          </Text>
          <Text>
            These days, Little Paul has chilled out a bit—probably because he’s running low on lives.
            Now he’s just vibing, living his best pirate life with his one eye.
          </Text>
          <Text>So yeah, that’s Little Paul for you—our chaotic, one-eyed legend! 🏴‍☠️</Text>
        </Card>

        {/* Right Image Card */}
        <ImageCard>
          <Image src={catImage} alt="Right Image" />
        </ImageCard>
      </Layout>
    </Container>
  );
};

export default Lore;
